"use strict";
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
var isZapTemplateNode = function (node) {
    return (node.tagName &&
        node.tagName === 'div' &&
        node.attrs &&
        node.attrs['data-zap-template-list'] === 'true');
};
exports.default = isZapTemplateNode;
